var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"filterable":"","filters":_vm.filters}},[_vm._v(" Controle Armazenamento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }